import { formatTimeWithMilliseconds } from '../../../common/common.utils'
import videojs from 'video.js'
import Player from 'video.js/dist/types/player'
import styles from '../VideoPlayer.module.less'

export class TimeWithMilliseconds extends videojs.getComponent('Component') {
    constructor(player: Player, options: object) {
        super(player, options)
        this.player().on('timeupdate', () => this.updateContent())
    }

    getContent() {
        const currentTime = this.player().currentTime() ?? 0
        const duration = Number.isNaN(this.player().duration() ?? 0) ? 0 : this.player().duration()
        return {
            currentTime: formatTimeWithMilliseconds(currentTime),
            duration: formatTimeWithMilliseconds(duration!),
        }
    }

    createEl() {
        const el = videojs.dom.createEl('div', { className: styles['vjs-time-milliseconds'] })
        const currentTimeEl = videojs.dom.createEl('span', {
            className: styles['current-video-time'],
            innerHTML: this.getContent().currentTime,
        })
        const durationEl = videojs.dom.createEl('span', {
            innerHTML: this.getContent().duration,
        })
        const separator = videojs.dom.createEl('span', {
            className: styles['separator'],
            innerHTML: '/',
        })
        el.appendChild(currentTimeEl)
        el.appendChild(separator)
        el.appendChild(durationEl)
        return el
    }

    updateContent() {
        const { currentTime, duration } = this.getContent()
        ;(this.el().children[0] as HTMLElement).innerText = currentTime
        ;(this.el().children[2] as HTMLElement).innerText = duration
    }
}
